<template>
  <b-row class="my-10">
    <b-col sm="12">
      <label class="fs-sa-14" for="page-title" style="padding-top: 7px">
        <span>{{ $t('engine.managePage.pageAddEdit.seo.lblTitle', languageEngine) }}</span>
        <span class="text-hint ml-3">({{ languageUse && languageUse.toUpperCase() }})</span>
        <span class="text-hint ml-3" v-b-tooltip.hover :title='$t("engine.managePage.pageAddEdit.seo.hintTitle", languageEngine)'>
          <i class="fas fa-question-circle"></i>
        </span> 
      </label>

      <label class="float-right text-muted fs-sa-14" style="padding-top: 7px">
        <span> <span :class="['text-'+progressCal({ str: title }).variant]">{{ value.length }}</span>/60 {{ $t("engine.managePage.pageAddEdit.seo.character", languageEngine) }} ({{width}}/{{config[mode].maxWidth}})</span>
      </label>
    </b-col>
    <b-col sm="12">
      <div 
        contenteditable="true"
        id="page-title"
        class="form-control"
        @keydown.enter.prevent
        :data-placeholder="$t('engine.managePage.pageAddEdit.seo.plcTitle', languageEngine)"
        :value="value"
        @input="handleInput"
      >{{value || ''}}</div>
      <b-progress style="height: 6px; margin-top: 5px">
        <b-progress-bar
          :value="progressCal({ str: title }).value"
          :variant="progressCal({ str: title }).variant"
        ></b-progress-bar>
      </b-progress>
      <div v-if="title">
        <div class="text-danger fs-sa-12" v-if="!countHeightlight"> 
          <i class="fas fa-exclamation-circle"></i>
          <span> {{ $t('engine.managePage.pageAddEdit.seo.errFocusKeywordTitle', languageEngine) }} </span>
        </div>
        <div class="text-success fs-sa-12" v-else>
          <i class="fas fa-check-circle"></i>
          <span> {{ $t("engine.managePage.pageAddEdit.seo.successFocusKeywordTitle", languageEngine) }} </span>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return { 
      config : {
        'desktop' : {
          maxWidth : "600px",
        },
        'mobile' : {
          maxWidth : "600px",
        },
      },
      countHeightlight : 0
    }
  },
  props: {
    value: {
      type: String,
    },
    title_default: {
      type: String,
    },
    mode: {
      type: String,
    },
    focusKeyword : {
      type : Array
    },
    width : {
      type : Number
    }
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      languageUse: "design/site/languageUse",
    }),
    title() {
      return this.value || this.title_default;
    },
  },
  methods: {
    progressCal({ max_str = 60, min_str = 50, str }) {
      const percent = (str.length / max_str) * 100;
      let color = "warning";
      if (str.length > max_str) {
        color = "danger";
      } else if (str.length >= min_str) {
        color = "success";
      }
      return {
        variant: color,
        value: percent,
      };
    },
    handleInput(value) {
      this.$emit("input", value.target.innerText);
    },
    updateEditor(isReposiotion) {
      let editor = document.getElementById("page-title");
      const sel = window.getSelection();
      const textSegments = this.getTextSegments(editor);
      const textContent = textSegments.map(({text}) => text).join('');
      let anchorIndex = null;
      let focusIndex = null;
      let currentIndex = 0;
      textSegments.forEach(({text, node}) => {
          if (node === sel.anchorNode) {
              anchorIndex = currentIndex + sel.anchorOffset;
          }
          if (node === sel.focusNode) {
              focusIndex = currentIndex + sel.focusOffset;
          }
          currentIndex += text.length;
      });
      
      editor.innerHTML = this.renderText(textContent);
      
      if(isReposiotion) { 
        this.restoreSelection(anchorIndex, focusIndex);
      }
    },
    renderText(text) {
      let value = this.focusKeyword[0];
      let highlightedText = "<span class=\"highlightedtitleclassmwenew\" style=\"color:#5c932f;\">$1</span>";
      const regex = '('+value+')';
      let temp = text.replaceAll(new RegExp(regex,'gi'),highlightedText);

      this.countHeightlight = (temp.match(/highlightedtitleclassmwenew/g) || []).length;

      return temp;
    },

    restoreSelection(absoluteAnchorIndex, absoluteFocusIndex) {
      let editor = document.getElementById("page-title");
      const sel = window.getSelection();
      const textSegments = this.getTextSegments(editor);
      let anchorNode = editor;
      let anchorIndex = 0;
      let focusNode = editor;
      let focusIndex = 0;
      let currentIndex = 0;
      textSegments.forEach(({text, node}) => {
          const startIndexOfNode = currentIndex;
          const endIndexOfNode = startIndexOfNode + text.length;
          if (startIndexOfNode <= absoluteAnchorIndex && absoluteAnchorIndex <= endIndexOfNode) {
              anchorNode = node;
              anchorIndex = absoluteAnchorIndex - startIndexOfNode;
          }
          if (startIndexOfNode <= absoluteFocusIndex && absoluteFocusIndex <= endIndexOfNode) {
              focusNode = node;
              focusIndex = absoluteFocusIndex - startIndexOfNode;
          }
          currentIndex += text.length;
      });
      
      sel.setBaseAndExtent(anchorNode,anchorIndex,focusNode,focusIndex);
    },
    getTextSegments(element) {
      const textSegments = [];
      Array.from(element.childNodes).forEach((node) => {
          switch(node.nodeType) {
              case Node.TEXT_NODE:
                  textSegments.push({text: node.nodeValue, node});
                  break;
                  
              case Node.ELEMENT_NODE:
                  textSegments.splice(textSegments.length, 0, ...(this.getTextSegments(node)));
                  break;
                  
              default:
                  throw new Error(`Unexpected node type: ${node.nodeType}`);
          }
      });
      return textSegments;
    }
  },
  mounted() {
    this.updateEditor(false);
    
  },
  watch : {
    value() {
      this.updateEditor(true);
    },
    focusKeyword() {
      this.updateEditor(false);
    }
  }
};
</script>

<style lang="scss">
#page-title {
  line-height:22px;
  min-height:32px;
  height:32px;
  max-height:32px;
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -ms-overflow-style: none; 
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  &:empty:before {
    content: attr(data-placeholder);
    color: #a5a5a5; 
  }
  &:empty:focus::before {
    content: attr(data-placeholder);
  }
}
</style>